export const localeToLanguageCode = (locale = '') => {
  if (!locale || locale === 'default' || !Intl.Locale) {
    return 'sv'
  }
  return new Intl.Locale(locale)?.language
}

export default localeToLanguageCode
